import { GET_SPECIALITY_FOR_DOCTOR } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Res {
    success: boolean;
    speciality?: SpecialityEntity[] | null;
    lab?: SpecialityEntity[];
    campaign: boolean;
}
export interface SpecialityEntity {
    name: string;
    s_name: string;
    id: number;
    doc_network?: DocNetworkEntity[] | null;
    doc_eka?: DocNetworkEntity[] | null;
    network?: DocNetworkEntity[] | null;
}
export interface DocNetworkEntity {
    name: Name;
    specialized: string;
    pic: string;
    _id: string;
    username: string;
    points: number;
    area: string;
    city: string;
    location: string;
    exprience?: string;
}
export interface Name {
    l: string;
    f: string;
}

export default (): Promise<Res> => {
    return fetchWithRefresh(GET_SPECIALITY_FOR_DOCTOR).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('GET_SPECIALITY_FOR_DOCTOR failed');
        }
    });
};
